import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React, { useEffect, useMemo, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { fromReactIntl, toReactIntl } from '../../util/formatLocale';
import { gql, useQuery } from '@apollo/client';
var GET_LOCALE = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query getLocale {\n        # eslint-disable-next-line @graphql-eslint/require-id-when-available\n        storeConfig {\n            store_code\n            locale\n        }\n    }\n"])));

var LocaleProvider = function LocaleProvider(props) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      messages = _useState2[0],
      setMessages = _useState2[1];

  var _useQuery = useQuery(GET_LOCALE, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first'
  }),
      data = _useQuery.data;

  var language = useMemo(function () {
    return data && data.storeConfig.locale ? toReactIntl(data.storeConfig.locale) : DEFAULT_LOCALE;
  }, [data]);
  /**
   * At build time, `__fetchLocaleData__` is injected as a global. Depending on the environment, this global will be
   * either an ES module with a `default` property, or a plain CJS module.
   *
   * Please see {LocalizationPlugin} at @magento/pwa-buildpack/WebpackTools/plugins/LocalizationPlugin.js
   */

  var fetchLocale = 'default' in __fetchLocaleData__ ? __fetchLocaleData__.default : __fetchLocaleData__;
  useEffect(function () {
    if (language) {
      var locale = fromReactIntl(language);
      fetchLocale(locale).then(function (data) {
        setMessages(data.default);
      }).catch(function (error) {
        console.error("Unable to load translation file. \n".concat(error));
      });
    }
  }, [fetchLocale, language]);

  var handleIntlError = function handleIntlError(error) {
    if (messages) {
      if (error.code === 'MISSING_TRANSLATION') {
        console.warn('Missing translation', error.message);
        return;
      }

      throw error;
    }
  };

  return React.createElement(IntlProvider, _extends({
    key: language
  }, props, {
    defaultLocale: DEFAULT_LOCALE,
    locale: language,
    messages: messages,
    onError: handleIntlError
  }));
};

export default LocaleProvider;